

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import List from "@/components/list/list.vue";
import Filters from "@/components/filters/filters.vue";
import { mapGetters, mapState } from "vuex";
import Request from "@/models/checkRequest/request";
import Project from "@/models/project/project";

@Component({
  components: {
    "uc-filters": Filters,
    "uc-list": List,
  },
  computed: {
    ...mapState("projects", ["requests", "activeRequestId", "queueBusy"]),
    ...mapGetters("projects", ["activeRequest"]),
    ...mapGetters("projects", ["activeProject", "requestsReady"]),
  },
})
export default class Requests extends Vue {
  // mapState + mapGetters
  activeProject!: Project;
  requests!: Array<Request>;
  activeRequestId!: string;
  queueBusy!: boolean;
  activeRequest!: Request;
  requestsReady!: Array<Request>;
}
